export const languageMap: Record<string, { label: string }> = {
  es: {
    label: 'Spanish'
  },
  en: {
    label: 'English'
  }
}
